namespace TabAurous.Purchase {
    export namespace POSQuotationItemsService {
        export const baseUrl = 'Purchase/POSQuotationItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<QuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/POSQuotationItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>POSQuotationItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
